 
import ChildrensTooltip from '../../../../components/common/ChildrensTooltip';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { trackerTooltips } from '@/app/KeywordTracker/tooltip/trackerTooltips';

type RankRendererProps = {
  rank: number;
};

const RankRenderer = ({ rank }: RankRendererProps) => {
  if (rank >=800)
    return (
      <> 
        {
        rank === 999 ? <span>بدون رتبه</span> : <span>&lt; {(parseInt(String(rank), 10) % 800) + 10}  </span>
        }
        <ChildrensTooltip
          placement="top"
          html={rank === 800 ? trackerTooltips.mainGrid.noRankInFirstPage :trackerTooltips.mainGrid.noRank}
        >
          <FontAwesomeIcon
            className="cursor-pointer text-warning fs--2"
            icon="exclamation-circle"
          />
        </ChildrensTooltip>
      </>
    );
  else if (rank === 100) return 'ورود';
  else if (rank === -100) return 'خروج';
  else return rank;
};

export default RankRenderer;
